import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { TextField } from '../../../../components/styledFormElements/TextField'
import { Loader } from '../../../../components/loader'
import { Button } from '../../../../components/ui/button'
import { getErrorResponse } from '../../../../services/util'
import { useNotificationBar } from '../../../../context/notificationContext'
import { useAddLanguage, useUpdateLanguageData } from '../../../../hooks/language-master'
import { ToggleField } from '../../../../components/styledFormElements/ToggleField'
import { DialogWrapper } from '../../../../components/dialogWrapper'
interface ComponentProps {
    isEditForm: boolean
    onSubmitHandler?: Function
    input_data: any
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const schema = yup
    .object({
        name: yup.string().required('Name is required'),
        code: yup.string().required('Code is required'),
        status: yup.boolean(),
    }).required()

const editSchema = yup
    .object({
        name: yup.string().required('Name is required'),
        code: yup.string().required('Code is required'),
    }).required()

export const AddUpdate: React.FC<ComponentProps> = ({ isEditForm, input_data, isOpen, setIsOpen, onSubmitHandler }) => {
    let schemaToUse = isEditForm ? editSchema : schema
    const { register, formState: { errors, dirtyFields }, reset, watch, handleSubmit, getValues } = useForm({
        resolver: yupResolver(schemaToUse),
        mode: 'onTouched',
    })
    const notification = useNotificationBar()

    const { mutate: addLanguage, isLoading: isLoadingAdd, isError: isErrorAdd } = useAddLanguage()
    const { mutate: updateLanguage, isLoading: isLoadingUpdate, isError: isErrorUpdate } = useUpdateLanguageData()

    let isLoading = isLoadingAdd || isLoadingUpdate

    useEffect(() => {
        let data: any = { ...input_data, status: !!input_data?.status }
        reset({ ...data })
    }, [input_data, reset])

    const onSubmit = (values: any) => {
        let data: any = values
        data.status = data.status ? 1 : 0
        if (input_data?.id) {
            let updated: any = {}
            Object.keys(dirtyFields).forEach((key: any) => {
                updated[key] = data[key]
            })
            if (!Object.keys(updated).length) {
                return onSubmitHandler && onSubmitHandler(data);
            }
            updateLanguage({
                data: updated,
                id: input_data?.id
            }, {
                onError(error: any) {
                    notification.push(getErrorResponse(error))
                },
                onSuccess(data, variables, context) {
                    notification.push({
                        title: 'Success !',
                        message: 'Language details has been updated successfully !',
                        type: 'success'
                    })
                    onSubmitHandler && onSubmitHandler(data);
                },
            })
        }
        else {

            addLanguage({
                data
            }, {
                onError(error: any) {
                    notification.push(getErrorResponse(error))
                },
                onSuccess(data, variables, context) {
                    notification.push({
                        title: 'Success !',
                        message: 'Language has been created successfully !',
                        type: 'success'
                    })
                    onSubmitHandler && onSubmitHandler(data);
                },
            })
        }
    }

    const onError = (errors: any) => {
        console.log('Form errors:', errors);
    };

    return (
        <DialogWrapper title={isEditForm ? 'Update User' : 'Create User'} isOpen={isOpen} setIsOpen={setIsOpen}>
            <form onSubmit={handleSubmit(onSubmit, onError)} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <TextField register={register('name')} errors={errors} label="Name: " />
                <TextField register={register('code')} errors={errors} label="Code: " placeholder="code:" />
                <ToggleField register={register('status')} label="Status: " display={watch('status') ? 'Active' : 'Inactive'} />
                <div className="col-span-full flex">
                    <div className="ml-auto flex gap-2 items-center">
                        <Button color="basic" disabled={isLoading} type="button" onClick={() => setIsOpen(false)}>Cancel</Button>
                        <Button color="blue" disabled={isLoading} type="submit">
                            {isLoading ? (
                                <><Loader /> Saving ...</>
                            ) : 'Save'}
                        </Button>
                    </div>
                </div>
            </form>
        </DialogWrapper>
    )
}